import { ExternalLink, ShieldCheck, Check } from "lucide-react";
import { toast } from "sonner";
import { Checkbox } from "@/components/ui/checkbox";
import { DRUG_PROGRAM_URL, CLEARINGHOUSE_URL, drugTestingApplies, drugTestingDone } from "@/lib/drugTesting";

const btn = "min-h-[44px] px-4 py-2 font-mono-label text-[11px] inline-flex items-center justify-center gap-2 transition-colors";

export function DrugTestingLinks({ tid = "drug" }) {
  return (
    <div className="grid grid-cols-1 sm:grid-cols-2 gap-2">
      <a href={DRUG_PROGRAM_URL} target="_blank" rel="noopener noreferrer" data-testid={`${tid}-program-link`}
        className={`${btn} cta-primary`}>
        <ExternalLink size={13} /> Testing program rules
      </a>
      <a href={CLEARINGHOUSE_URL} target="_blank" rel="noopener noreferrer" data-testid={`${tid}-clearinghouse-link`}
        className={`${btn} border border-[#262626] hover:border-white`}>
        <ExternalLink size={13} /> Register on Clearinghouse
      </a>
    </div>
  );
}

export default function DrugTestingCard({ profile, api, onChanged, readOnly }) {
  const done = drugTestingDone(profile);
  const toggle = async (v) => {
    try {
      await api.put("/filings/drug_testing", { status: v ? "completed" : "not_started" });
      toast.success(v ? "Marked as enrolled" : "Marked as not enrolled");
      window.dispatchEvent(new Event("drug-testing-changed"));
      onChanged();
    } catch {
      toast.error("Could not update. Please try again.");
    }
  };
  return (
    <section id="drug-testing" className="brutal-border mb-6 scroll-mt-24" data-testid="compliance-item-drug-testing">
      <div className="px-4 py-3 border-b border-[#262626] bg-[#141414] flex items-center justify-between gap-3">
        <div className="min-w-0">
          <div className="font-heading font-bold inline-flex items-center gap-2"><ShieldCheck size={16} className="text-[#FFD600]" /> Drug & Alcohol Testing</div>
          <div className="font-mono-label text-[10px] text-muted-foreground">DOT PROGRAM · 49 CFR PART 382</div>
        </div>
        <span data-testid="drug-status" className={`shrink-0 font-mono-label text-[10px] px-2 py-1 ${done ? "bg-[#16A34A] text-white" : "bg-[#F59E0B] text-black"}`}>
          {done ? "ENROLLED" : drugTestingApplies(profile) ? "REQUIRED" : "CHECK"}
        </span>
      </div>
      <div className="p-4 space-y-4">
        <p className="text-sm text-muted-foreground leading-relaxed">
          FMCSA requires every carrier with CDL drivers to run a DOT drug & alcohol testing program, usually by joining a testing consortium. You also need to register on the Drug & Alcohol Clearinghouse and check each driver before they drive.
        </p>
        <DrugTestingLinks tid="compliance-drug" />
        {!readOnly && (
          <label className="flex items-center gap-3 min-h-[44px] cursor-pointer" data-testid="drug-enrolled-label">
            <Checkbox checked={done} onCheckedChange={(v) => toggle(!!v)} data-testid="drug-enrolled-checkbox" />
            <span className="text-sm">My drivers are enrolled in a DOT drug & alcohol testing program</span>
            {done && <Check size={14} className="text-[#16A34A]" />}
          </label>
        )}
      </div>
    </section>
  );
}
